const BannerSkeleton = () => {
    return (
        <div className='banner skeleton'>
            <div className='bannercontent'>
                <div className='bannertext'>
                    <div className='title'></div>
                    <div className='text'></div>
                    <div className='texttwo'></div>
                </div>

            </div>
        </div>
    )
}


export default BannerSkeleton;